import {  TextField, Typography } from "@mui/material";
import { BoxFC,  } from "components/BoxCustom";
import React, { useCallback, useMemo } from "react";
import {  moveRowTo } from "utils";
import { Box } from "@mui/system";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { columns } from "./columns";

const DailyTableColWidthContent = ({ dailyTableColWidth, setDailyTableColWidth }) => {

  const [filter, setFilter] = React.useState("")

  const modDailyTableColWidth = useMemo(()=>{
    return filter ? dailyTableColWidth.filter((row) => row.headerName.toLowerCase().indexOf(filter.toLowerCase()) > -1) : dailyTableColWidth
  }, [dailyTableColWidth, filter])

  const handleChangeCol = useCallback((id, field, value) => {
   
    setDailyTableColWidth(o => {
      const result = [...o]
      const row = result.find(r => r.id === id)
     
      row[field] = value
     
      return result
    })
  }, [setDailyTableColWidth])

  const handleRowOrderChange = useCallback((params) => {
   
    setDailyTableColWidth(o => moveRowTo(o, params.oldIndex, params.targetIndex).map((row, index) => ({ ...row, order: index })))
  }, [setDailyTableColWidth])


  const handleEditCommit = useCallback((params,  e) => {
    
    
    if (params.field === "width") {
      handleChangeCol(params.id, params.field, params.value)
    }
  }, [handleChangeCol])

 
  return (
    <BoxFC height="100%" sx={{ gap: 1 }}>
      <Typography variant="h6">ตารางงานประจำวัน</Typography>
      <TextField value={filter} size="small" sx={{width: 150}} 
        onChange={(e) => setFilter(e.target.value)} label="Filter" variant="outlined"  />
      <Box flex={1} width={650} sx={{
        "& .MuiOutlinedInput-notchedOutline": {borderWidth: 0}
      }}>
        <DataGridCellExpand
          disableSelectionOnClick
          rowReordering
          onRowOrderChange={handleRowOrderChange}
          hideFooter
          hideToolbar
          rows={modDailyTableColWidth}
          columns={columns(handleChangeCol)}
          onCellEditCommit={handleEditCommit}
        />
      </Box>
    </BoxFC>
  )
}

export default React.memo(DailyTableColWidthContent)